import { Stack, Text, Box } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { CalendarEvent } from 'src/meetings/models';
import { groupEventsByDate, getDateSectionHeader, Order } from 'src/meetings/utils/date-utils';

type Props = {
  events: CalendarEvent[];
  emptyMessage?: string;
  renderCard: (event: CalendarEvent) => React.ReactNode;
  order?: Order;
};

export const EventsList = ({ events, emptyMessage, renderCard, order = 'asc' }: Props) => {
  if (events.length === 0) {
    return (
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.6" ta="center" mt="lg">
        {emptyMessage}
      </Text>
    );
  }

  const groupedEvents = groupEventsByDate(events, order);

  return (
    <Box pb="xxl">
      {Array.from(groupedEvents.entries()).map(([dateKey, dateEvents]) => {
        const date = new Date(dateKey);
        const header = getDateSectionHeader(date);

        return (
          <Box key={dateKey}>
            <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.6" mt="lg" mb="xxs">
              {header}
            </Text>
            <Stack gap="xxs">
              {dateEvents.map(event => (
                <Box key={event.id}>{renderCard(event)}</Box>
              ))}
            </Stack>
          </Box>
        );
      })}
    </Box>
  );
};
